import React from 'react';
import { cn } from '@/lib/utils';
import { Label } from '@/components/ui/label';

interface FormFieldProps {
  label: string;
  htmlFor?: string;
  children: React.ReactNode;
  className?: string;
}

/**
 * A reusable component to consistently display a label
 * vertically stacked above its corresponding value or input field.
 * Ensures consistent spacing and label styling.
 */
export function FormField({ label, htmlFor, children, className }: FormFieldProps) {
  return (
    <div className={cn("space-y-1", className)}> 
      <Label
        htmlFor={htmlFor}
        className="text-sm font-medium text-gray-500"
      >
        {label}
      </Label>
      {children} {/* Children should handle their own padding (e.g., pl-0 pr-3 py-2) */}
    </div>
  );
} 